// removed by extract-text-webpack-plugin
module.exports = {"header":"styles__header___VeLZ","chevron":"styles__chevron__2gTLG","headerText":"styles__headerText__31tCj","content":"styles__content__3HT_w","separator":"styles__separator__1Jg5H","chevronIcon":"styles__chevronIcon__8oT93"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CollapseText/styles.css
// module id = 2170
// module chunks = 0